module.exports = __webpack_public_path__ + "img/logo-contacto.9e0126d1.webp";